import { writable } from 'svelte/store';
export const notallowed = writable(false);
